import type { Template } from "@/types";

export const LA_07_H1_V6: Template[] = [
    {
        id: "la-07-h1v6-01",
        name: "LA 01 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h1_v6_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 44, y: 55, width: 587, height: 373, rotation: 0, imageRotation: 0 },
            { id: "2", x: 800, y: 31, width: 137, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 800, y: 245, width: 138, height: 206, rotation: 0, imageRotation: 0 },
            { id: "4", x: 945, y: 31, width: 138, height: 206, rotation: 0, imageRotation: 0 },
            { id: "5", x: 945, y: 245, width: 138, height: 206, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1090, y: 31, width: 139, height: 206, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1090, y: 245, width: 139, height: 206, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-02",
        name: "LA 02 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h1_v6_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 163, y: 50, width: 350, height: 220, rotation: 0, imageRotation: 0 },
            { id: "2", x: 163, y: 277, width: 111, height: 155, rotation: 0, imageRotation: 0 },
            { id: "3", x: 282, y: 277, width: 111, height: 155, rotation: 0, imageRotation: 0 },
            { id: "4", x: 401, y: 277, width: 112, height: 155, rotation: 0, imageRotation: 0 },
            { id: "5", x: 811, y: 50, width: 266, height: 382, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1084, y: 50, width: 133, height: 187, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1084, y: 245, width: 133, height: 187, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-03",
        name: "LA 03 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h1_v6_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 144, y: 50, width: 388, height: 243, rotation: 0, imageRotation: 0 },
            { id: "2", x: 144, y: 301, width: 91, height: 132, rotation: 0, imageRotation: 0 },
            { id: "3", x: 243, y: 301, width: 91, height: 132, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 301, width: 91, height: 132, rotation: 0, imageRotation: 0 },
            { id: "5", x: 441, y: 301, width: 91, height: 132, rotation: 0, imageRotation: 0 },
            { id: "6", x: 811, y: 96, width: 200, height: 291, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1019, y: 96, width: 199, height: 291, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-04",
        name: "LA 04 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h1_v6_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 194, y: 50, width: 281, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 194, y: 235, width: 137, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 338, y: 235, width: 137, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 833, y: 50, width: 267, height: 382, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1108, y: 50, width: 87, height: 122, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1108, y: 180, width: 87, height: 122, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1108, y: 310, width: 87, height: 122, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-05",
        name: "LA 05 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h1_v6_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 194, y: 50, width: 281, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 194, y: 235, width: 137, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 338, y: 235, width: 137, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 869, y: 50, width: 141, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 869, y: 245, width: 141, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 50, width: 140, height: 188, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 245, width: 140, height: 188, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-06",
        name: "LA 06 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h1_v6_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 91, y: 85, width: 495, height: 312, rotation: 0, imageRotation: 0 },
            { id: "2", x: 865, y: 36, width: 196, height: 272, rotation: 0, imageRotation: 0 },
            { id: "3", x: 865, y: 316, width: 94, height: 131, rotation: 0, imageRotation: 0 },
            { id: "4", x: 967, y: 316, width: 94, height: 131, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1069, y: 36, width: 94, height: 132, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1069, y: 176, width: 94, height: 132, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1069, y: 316, width: 94, height: 131, rotation: 0, imageRotation: 0 },
           
        ],
    },

    {
        id: "la-07-h1v6-07",
        name: "LA 07 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h1_v6_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 91, y: 85, width: 495, height: 312, rotation: 0, imageRotation: 0 },
            { id: "2", x: 865, y: 36, width: 94, height: 132, rotation: 0, imageRotation: 0 },
            { id: "3", x: 865, y: 176, width: 94, height: 132, rotation: 0, imageRotation: 0 },
            { id: "4", x: 865, y: 316, width: 94, height: 131, rotation: 0, imageRotation: 0 },
            { id: "5", x: 967, y: 36, width: 94, height: 132, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1069, y: 36, width: 94, height: 132, rotation: 0, imageRotation: 0 },
            { id: "7", x: 967, y: 176, width: 196, height: 271, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-08",
        name: "LA 08 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h1_v6_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 137, y: 70, width: 402, height: 227, rotation: 0, imageRotation: 0 },
            { id: "2", x: 137, y: 303, width: 74, height: 110, rotation: 0, imageRotation: 0 },
            { id: "3", x: 219, y: 303, width: 74, height: 110, rotation: 0, imageRotation: 0 },
            { id: "4", x: 301, y: 303, width: 74, height: 110, rotation: 0, imageRotation: 0 },
            { id: "5", x: 383, y: 303, width: 74, height: 110, rotation: 0, imageRotation: 0 },
            { id: "6", x: 465, y: 303, width: 74, height: 110, rotation: 0, imageRotation: 0 },
            { id: "7", x: 833, y: 0, width: 344, height: 483, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h1v6-09",
        name: "LA 09 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h1_v6_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 48, width: 262, height: 388, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 48, width: 262, height: 388, rotation: 0, imageRotation: 0 },
            { id: "3", x: 539, y: 48, width: 126, height: 190, rotation: 0, imageRotation: 0 },
            { id: "4", x: 539, y: 246, width: 126, height: 190, rotation: 0, imageRotation: 0 },
            { id: "5", x: 673, y: 48, width: 545, height: 388, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1226, y: 48, width: 126, height: 190, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1226, y: 246, width: 126, height: 190, rotation: 0, imageRotation: 0 }        
        ],
    },

    {
        id: "la-07-h1v6-10",
        name: "LA 10 - H1V6",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-07-h1_v6_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 48, width: 262, height: 388, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 48, width: 262, height: 388, rotation: 0, imageRotation: 0 },
            { id: "3", x: 539, y: 48, width: 275, height: 190, rotation: 0, imageRotation: 0 },
            { id: "4", x: 539, y: 246, width: 134, height: 190, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 246, width: 133, height: 190, rotation: 0, imageRotation: 0 },
            { id: "6", x: 820, y: 48, width: 262, height: 388, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1090, y: 48, width: 262, height: 388, rotation: 0, imageRotation: 0 },            
        ],
    }
];